<template>
  <v-list-item :href="item.url">
    <v-list-item-content>
      <v-list-item-title class="top-topic">
        <v-row no-gutters>
          <v-col cols="auto" class="top-topic-date">
            <time class="d-block">{{item.date}}</time>
          </v-col>
          <v-col cols="auto" class="top-topic-category">
            <span class="d-block text-right text-sm-left">{{item.category}}</span>
          </v-col>
          <v-col cols="12" sm>
            <span class="d-block pt-2 pt-sm-0 pl-sm-2">{{item.text}}</span>
          </v-col>
        </v-row>
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: 'CItem',
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss">
.top-topic {
  overflow: auto;
  text-overflow: initial;
  white-space: initial;

  .top-topic-date {
    width: 4.5rem;
  }

  .top-topic-category {
    width: 5rem;
  }
}
</style>
